import { Box, Tooltip } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import InlineTooltip from 'modules/core/components/InlineTooltip'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import { leaveEmployee } from 'modules/timeoff/lib/leaveEmployees'
import type Leave from 'modules/timeoff/store/models/Leave'

interface Props {
  leave: Leave
}

const MedicalLeaveTooltip = ({ leave }: Props) => {
  const { navigation } = useNavigation()

  if (!leave.policy.can('updateLeave')) return null
  if (!leave.policy.can('manageLeaveDocuments')) return null

  const myRoute = navigation.timeOff.leaveUpdatesLeaveIdNew.fullPath({ leave_id: leave.id })

  const employee = leaveEmployee(leave)
  const employeeRoute = navigation.employees.id.timeOff.leaveUpdatesLeaveIdNew.fullPath({
    id: employee.id,
    leave_id: leave.id,
  })

  const route = users.current.employee?.id === employee.id ? myRoute : employeeRoute

  return (
    <InlineTooltip compact type="brand" arrow="bottom">
      <Box alignItems="center" justifyContent="center" padding="s24">
        {i18n.t('time_off.medical_leave.updates.create_update.description')}
      </Box>
      <Tooltip.Button to={route}>
        {i18n.t('time_off.medical_leave.updates.create_update.button')}
      </Tooltip.Button>
    </InlineTooltip>
  )
}

export default observer(MedicalLeaveTooltip)
